<template>
  <client-page>
    <main class="letter-page">
      <section class="letter-card">
        <p class="eyebrow">MUZIN LETTER</p>
        <h1>영상·콘텐츠 실무정보를 짧게 보내드립니다.</h1>
        <p class="lead">지원사업, 영상기획, 제작 실무에서 바로 쓸 수 있는 내용을 주 1회 내외로 정리합니다.</p>

        <form v-if="!done" @submit.prevent="submit">
          <label>
            <span>회사·브랜드명 <em>선택</em></span>
            <input v-model.trim="company" type="text" maxlength="120" autocomplete="organization">
          </label>
          <label>
            <span>이메일</span>
            <input v-model.trim="email" type="email" maxlength="254" required autocomplete="email">
          </label>
          <label class="consent">
            <input v-model="consent" type="checkbox">
            <span>MUZIN LETTER 및 영상·콘텐츠 실무정보 이메일 수신에 동의합니다. <b>(선택 / 주 1회 내외 / 언제든 수신거부 가능)</b></span>
          </label>
          <p v-if="error" class="error">{{ error }}</p>
          <button :disabled="busy || !consent" type="submit">{{ busy ? "저장 중..." : "MUZIN LETTER 받기" }}</button>
          <p class="note">수신동의는 선택이며, 언제든 메일의 수신거부 또는 이 페이지에서 철회할 수 있습니다.</p>
        </form>

        <div v-else class="success">
          <strong>등록되었습니다.</strong>
          <p>{{ email }} 주소로 MUZIN LETTER를 보내드릴 수 있도록 저장했습니다.</p>
          <button type="button" @click="reset">다른 주소 등록</button>
        </div>

        <div class="unsubscribe">
          <p>이미 받고 계신가요?</p>
          <button type="button" @click="unsubscribe">이 이메일 수신거부</button>
        </div>
      </section>
    </main>
  </client-page>
</template>

<script>
import axios from "axios";
import ClientPage from "@/pages/client/templates/ClientPage.vue";

export default {
  name: "NewsletterSubscribe",
  components: { ClientPage },
  data() {
    return { company: "", email: "", consent: false, busy: false, done: false, error: "" };
  },
  methods: {
    async submit() {
      this.error = "";
      if (!this.consent) {
        this.error = "이메일 수신 동의를 선택해 주세요.";
        return;
      }
      this.busy = true;
      try {
        const { data } = await axios.post("/api/newsletter/subscribe", {
          company: this.company,
          email: this.email,
          consent: true
        }, { timeout: 15000 });
        if (!data || data.ok !== true) throw new Error("저장 실패");
        this.done = true;
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.error) || "구독 신청을 저장하지 못했습니다.";
      } finally {
        this.busy = false;
      }
    },
    async unsubscribe() {
      this.error = "";
      if (!this.email) {
        this.error = "수신거부할 이메일 주소를 입력해 주세요.";
        return;
      }
      this.busy = true;
      try {
        const { data } = await axios.post("/api/newsletter/unsubscribe", { email: this.email }, { timeout: 15000 });
        if (!data || data.ok !== true) throw new Error("처리 실패");
        this.done = true;
        this.consent = false;
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.error) || "수신거부를 처리하지 못했습니다.";
      } finally {
        this.busy = false;
      }
    },
    reset() {
      this.company = ""; this.email = ""; this.consent = false; this.done = false; this.error = "";
    }
  }
};
</script>

<style scoped>
.letter-page{min-height:78vh;background:#fff;padding:120px 24px 80px;display:flex;justify-content:center}
.letter-card{width:100%;max-width:720px;border:1px solid #e7eaf0;padding:44px;border-radius:24px}
.eyebrow{font-size:13px;letter-spacing:.14em;color:#2457ff;margin:0 0 14px}
h1{font-size:36px;line-height:1.2;margin:0 0 18px;color:#111827}
.lead{font-size:17px;line-height:1.7;color:#5b6474;margin-bottom:34px}
label{display:block;margin:18px 0}
label>span{display:block;font-size:14px;margin-bottom:8px;color:#111827}
em{font-style:normal;color:#8b93a1}
input[type="text"],input[type="email"]{width:100%;box-sizing:border-box;border:1px solid #d8dee8;border-radius:12px;padding:14px 15px;font-size:16px}
.consent{display:flex;gap:10px;align-items:flex-start}
.consent input{margin-top:3px;width:18px;height:18px}
.consent span{margin:0;line-height:1.55}
.consent b{font-weight:400;color:#6c7482}
button{border:0;border-radius:12px;background:#2457ff;color:#fff;padding:14px 20px;font-size:15px;cursor:pointer}
button:disabled{opacity:.45;cursor:not-allowed}
.note,.unsubscribe,.error{font-size:13px;color:#737b89;margin-top:14px}
.error{color:#b42318}
.success{padding:18px 0 28px}
.success strong{font-size:24px}
.unsubscribe{border-top:1px solid #eceff4;padding-top:24px;margin-top:32px}
.unsubscribe button{background:#111827;padding:10px 14px}
@media(max-width:640px){.letter-page{padding:92px 16px 50px}.letter-card{padding:28px 20px;border-radius:18px}h1{font-size:28px}}
</style>
